module.exports = __webpack_public_path__ + "static/media/close-circle.c1e6cfad.svg";